require('./stylesheets/_registration.scss');

angular.module('pages.login', [])
	.config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
	$stateProvider
		.state('pages.login', {
			url: 'login',
			template: require('./templates/index.html'),
			controller: require('./controllers/login.js'),
			data: {
				iframe: false
			},
			params: {
				registration: null,
				focusBack: null
			},
			pageTrack: '/login'
		});
}

module.exports = 'pages.login';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/login/index.js
 ** module id = 265
 ** module chunks = 1
 **/